<template>
  <div class="page" style="padding-top: 66px;">
    <img class="bg-pic" src="@/assets/new/company.png" alt="" />
    <div class="content-center">
      <div class="name">
        <p>谢一鸣</p>
        <p>集团创始人</p>
      </div>
      <div class="content">
        <img src="@/assets/new/xieyiming.png" alt="" />
        <div class="position">福州市中小企业联合会副会长</div>
        <br />
        <div class="achievement">
          <p>聚合云集团董事长，耕耘支付行业十余年，参与了第三方支付从牌照申请时期的萌芽成长、百花齐放时期的高速发展到激烈竞争时期的创新出彩的各个阶段。先后在两家全国牌照支付公司任VP，平台年交易量均超万亿规模，跻身银行收单行业TOP10。擅长从0到1和多任务管理，拥有丰富的行业资源和战略规划能力。</p>
        </div>
        <div class="foot-but">
          <el-button type="primary">店收盈APP</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Originator",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.page {
  .bg-pic {
    width: 100%;
    display: block;
  }
}

/* PC端样式（保持你原来的） */
.content-center {
  max-width: 1200px;
  margin: 0 auto;
  padding: 30px 20px;
}
.name {
  padding: 30px 0 30px 420px;
}
.name p:nth-of-type(1) {
  color: #333;
  font-size: 40px;
}
.name p:nth-of-type(2) {
  color: #707172;
  font-size: 20px;
}
.content {
  position: relative;
  padding: 50px 50px 50px 420px;
  background-color: #f9fafc;
  font-size: 20px;
  color: #707172;
  line-height: 1.6;
}
.content .position {
  font-size: 24px;
  color: #333;
  margin-bottom: 15px;
}
.content .achievement {
  padding-bottom: 20px;
  border-bottom: 2px solid #707172;
}
.content img {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 400px;
  object-fit: contain;
}
.foot-but .el-button {
  margin-top: 30px;
  border: none;
  padding: 12px 24px;
  background-color: #de1f26;
  color: #fff;
}

/* ====================== 移动端适配（自动生效） ====================== */
@media screen and (max-width: 768px) {
  .content-center {
    padding: 20px 15px;
  }
  .name {
    padding: 20px 0;
    text-align: center;
  }
  .name p:nth-of-type(1) {
    font-size: 28px;
  }
  .name p:nth-of-type(2) {
    font-size: 16px;
  }
  .content {
    padding: 30px 20px;
    text-align: center;
  }
  .content img {
    position: static;
    transform: none;
    width: 80%;
    max-width: 280px;
    margin: 0 auto 20px;
    display: block;
  }
  .content .position {
    font-size: 20px;
  }
  .content {
    font-size: 16px;
  }
  .achievement {
    text-align: left;
  }
}
</style>
